export default __webpack_public_path__ + "static/media/noun-electronic-bill-4743811.dbe7cf94.svg";